import { defineStore } from 'pinia';
export const useSidebarStore = defineStore('sidebar', () => {
    let menus = [];
    const storageName = 'sidebar-state';
    const sessionStorage = window.sessionStorage;
    const savedState = sessionStorage.getItem(storageName);
    if (savedState) {
        menus = JSON.parse(savedState);
    }
    function getMenu(label) {
        return menus.find((m) => m.label === label) ?? null;
    }
    function saveMenuState() {
        sessionStorage.setItem(storageName, JSON.stringify(menus));
    }
    function readMenuState(label) {
        let menu = getMenu(label);
        if (!menu) {
            menu = registerMenu(label);
        }
        return menu.isExpanded;
    }
    function updateMenuState(label, value) {
        const menu = getMenu(label);
        if (menu) {
            menu.isExpanded = value;
            saveMenuState();
        }
    }
    function registerMenu(label) {
        const menu = { label, isExpanded: true };
        menus.push(menu);
        saveMenuState();
        return menu;
    }
    function reset() {
        menus = [];
        sessionStorage.removeItem(storageName);
    }
    return {
        menus,
        updateMenuState,
        readMenuState,
        reset
    };
});
